import type { Unsubscribe } from "@reduxjs/toolkit";
import {  userConnectRequest } from ".";
import { AppStartListening } from "..";

export function initAppListeners(
  startListening: AppStartListening
): Unsubscribe {
  const subscriptions = [
    startListening({
      actionCreator: userConnectRequest,
      effect: async (action, { dispatch, getState }) => {
        const { payload: { jwt } } = action;
        localStorage.setItem("jwt", jwt);
      },
    }),
  ];
  return () => {
    subscriptions.forEach((unsubscribe) => unsubscribe());
  };
}
